const cookieName = 'registerLandingUrl';

function readSessionLandingUrl() {
  if (process.client) {
    try {
      return sessionStorage.getItem(cookieName);
    } catch (error) {
      // Browser privacy settings can disable storage; fall back to the cookie.
    }
  }
  return null;
}

export function saveRegisterLandingUrl(cookies, url) {
  if (typeof url === 'string' && url) {
    if (process.client) {
      try {
        sessionStorage.setItem(cookieName, url);
      } catch (error) {
        // Keep the cookie fallback when sessionStorage is unavailable.
      }
    }
    // A session cookie can be written during SSR, even when browser JS is disabled.
    cookies.set(cookieName, url, {
      path: '/',
      sameSite: 'lax',
      secure: process.env.cookie_secure === true || process.env.cookie_secure === 'true'
    });
  }
}

export function resolveRegisterLandingUrl({ app, route, from }) {
  const candidates = [
    route.query.registerLandingUrl,
    from?.name === 'landing-url' ? from.params?.url : null,
    readSessionLandingUrl(),
    // Slugs such as "123" must remain strings, rather than being parsed as JSON.
    app.$cookies.get(cookieName, { parseJSON: false })
  ];
  const url = candidates.find(value => typeof value === 'string' && value) || null;
  saveRegisterLandingUrl(app.$cookies, url);
  return url;
}

export function clearRegisterLandingUrl(cookies) {
  if (process.client) {
    try {
      sessionStorage.removeItem(cookieName);
    } catch (error) {
      // Cookie cleanup must still run when sessionStorage is unavailable.
    }
  }
  cookies.remove(cookieName, { path: '/' });
}
